<template>
  <div id="sssearchDialog" class="sssearchDialog">
    <el-dialog
      style="margin-top:0vh !important;"
      :title="title"
      :visible.sync="searchVisible"
      width="680px"
      :before-close="closeSearch"
    >
      <div class="search-box" style="height:40px;margin-bottom: 15px;display:flex;">
        <el-input v-model="keyWord" @change="onSearch" @keydown.enter.native="onSearch" />
        <el-button class="search-btn" @click="onSearch">搜索</el-button>
        <!-- <i style="float:right;font-size:22px;line-height: 50px;" class="el-icon-refresh" @click="onSearch" /> -->
      </div>
      <el-table
        ref="myTable"
        v-loading="loading"
        size="mini"
        :data="tableData"
        highlight-current-row
        style="width: 100%"
        :row-key="idProperty"
        @selection-change="handleSelectChange"
      >
        <el-table-column
          :reserve-selection="isCheckBox"
          align="center"
          type="selection"
          width="55"
        />
        <el-table-column
          align="center"
          type="index"
          width="45"
        />
        <el-table-column
          :property="idProperty"
          :label="idName"
        />
        <el-table-column
          :property="nameProperty"
          :label="nameName"
        />
      </el-table>
      <div class="pagination">
        <el-pagination
          class="commodity-pagination"
          background
          :current-page.sync="currentPage"
          :page-sizes="[5,10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="onSearch"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="close-btn" @click="closeSearch">取 消</el-button>
        <el-button size="small" class="confirm-btn" type="primary" @click="cfmSearchStore">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  props: {
    searchUrl: {
      type: String,
      default: ''
    },
    searchVisible: {
      type: Boolean
    },
    title: {
      type: String,
      default: ''
    },
    tableName: {
      type: String,
      default: ''
    },
    questMethod: {
      type: String,
      default: 'post'
    },
    idProperty: {
      type: [String],
      default: 'fid'
    },
    nameProperty: {
      type: [String],
      default: 'fname'
    },
    pagination: {
      type: [Boolean],
      default: true
    },
    idName: {
      type: [String],
      default: '编号'
    },
    nameName: {
      type: [String],
      default: '名称'
    },
    keyWordName: {
      type: [String],
      default: 'keyWord'
    },
    isCheckBox: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      keyWord: '',
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selectArr: []
    }
  },
  watch: {
    searchVisible(val) {
      if (val) {
        this.onSearch()
      }
    }
  },
  created() {
    // this.onSearch()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    },
    cfmSearchStore() {
      const s = this.$refs.myTable.selection
      this.currentRow = s.length ? s[0] : null
      this.$emit('cfmSearch', this.currentRow, this.selectArr)
      this.$refs.myTable.clearSelection()
    },
    closeSearch() {
      this.$refs.myTable.clearSelection()
      this.$emit('closeSearch')
    },
    onSearch() {
      this.loading = true
      const params = {
        tableName: this.tableName,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      params[this.keyWordName] = this.keyWord
      if (!this.pagination) {
        params.pageNo = -1
      }
      request({
        url: this.searchUrl,
        method: this.questMethod,
        params
      })
        .then(res => {
          this.tableData = res.rows || res.data.records || res.data
          this.total = res.total || res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSelectChange(val) {
      if (this.isCheckBox) {
        this.selectArr = val
        return
      }
      if (val.length > 1) {
        this.$refs.myTable.clearSelection()
        this.$refs.myTable.toggleRowSelection(val.pop())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#sssearchDialog {
    .search-btn {
        width: 72px;
        height: 40px;
        background: #EC212D;
        color: #fff;
        margin-left: 32px;
    }
    .pagination {
        position: relative;
        top: 10px;
        width:100%;
        height:35px;
    }
}
</style>
<style lang="scss">
#sssearchDialog {
    .el-dialog {
        margin-top: -8vh !important;
    }
}
.sssearchDialog {
    .search-box {
        .el-input__inner {
            width: 240px;
            height: 40px !important;
        }
        .el-input {
            width: 240px;
        }
    }
    thead {
        .el-table-column--selection {
        .cell {
            display: none;
        }
        }
    }
    .el-dialog {
        border-radius: 10px;
        height: 518px !important;
    }
    .serchIpt {
        width: 300px;
        height: 28px;
    }

    .searchBtn {
        margin-left: 30px;
        color: #fff;
        background: #2db0a0;
    }
    .commodity-pagination{
        // margin-top: 5px;
        float: right;
    }
    .el-table__body-wrapper{
      height: 238px !important;
      overflow-y: auto !important;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #EC212D;
    }
    .el-dialog__body {
        padding: 20px 24px !important;
        height: 405px !important;
        border-bottom: 1px solid #C4CBD7;
        overflow-y: auto !important;
    }
    .el-dialog__header {
        border-radius: 10px 10px 0 0;
        text-align: left;
        background: #EC212D;
        height: 40px;
        padding-left: 20px;
        .el-dialog__title {
            color: #fff;
        }
    }
    .el-dialog__footer {
        display: flex;
        justify-content: right;
        align-items: center;
        padding: 0;
        height: 73px;
        text-align: center;
        padding-right: 35px;
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
    .el-form-item__label {
        width: 90px !important;
    }
    .el-form-item__content {
        margin-left: 90px !important;
    }
    .dialog-footer {
        text-align: center;
        .confirm-btn {
            background: #EC212D;
        }
        .close-btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
